
  import React from "react";

const brandStyles = {
    primaryGreen: '#91C949',
    deepBlue: '#394C92',
    linkHover: '#68A637',
    lightBg: '#F0F5EB',
};

// --- Frame Image Paths (Already defined correctly in the original code) ---
const BlueFrame = "/images/Sustainability/BlueFrame.png"; 
const GreenFrame = "/images/Sustainability/GreenFrame.png";

export default function Sustainability() {
  const bannerImage = "/images/Sustainability/Calf.jpg";

  const initiatives = [
    {
      title: "Ag-liberte – Comprehensive Sustainability Program",
      description:"Ag-liberte is an initiative of Sristi Bio-sciences Private Limited that manages five different social/technological initiatives with a common agenda of sustainability practices for our traceable agriculture supply chain that contributes to Orgavitaz and its raw materials. Each initiative has been invested and promoted as an inevitable component of our organic supply chain. Since 2014, these initiatives are developed in various forms and integrated now into a common platform called Agliberte in September 2019. Consistent rejections of quality farm produce and the malpractices in organic farming system has led to this program called Agliberte that envisages a sustainable, traceable and consistent supply chain. The initatives have six engines ensuring sustainable and unique supply chain.",
      image: "/images/Sustainability/Agliberte-CSP.png",
    },
    {
      title: "Ceora",
      description:"Center of Excellence in Organicology & Regenesis of Agro-ecology – This is an initiative driven by agriculture scientists and cross-functional experts from other scientific disciplines to innovate and extend simple farm interventions that protects agro-ecology of a farm. CEORA has been consistently building models on systemic impact of agro-ecology on functional resources of farm productivity. The excellence centre advocates the significance of conservative practices and their impact on sustainable farm resources as a continuous extension activity in organic and bio-dynamic farms. The center participates in consistent interventions and its influences as against a typical compliance intervention.",
      image: "/images/Sustainability/Ceora.png",
    },
    {
      title: "Organova Bio-Agriculture",
      description:"Organova Bio-Agriculture is our agriculture supply chain initiative that runs captive, co-operative and contract farming (3C Supply chain model) for enabling consistent supply of raw materials without any breakdown. Since 2015, Oganova has contributed to an improved and relatively stable supply chain. However, it is too long term an objective to accomplish in 5 years. We consider this activity as backbone for the future supply chain. Currently, 2100 acres of controlled cultivation is under the lens of Organova. Organova supplies certified raw materials and qualified seed material for this purpose. The farmers are monitored through an iGACP. The program also includes 730 acres of certified wild area for picking approved material. The program also integrates 100 ICS for a scalable model of consolidated development for the future through a structured Joint Liability groups based farm financing.",
      image: "/images/Sustainability/Organova-Bio-Agri.jpg",
    },
    {
      title: "Conserv",
      description:"This initiative is the first non-GMO activity of its kind. Conserv has three aspects to its work mandate. First, monitoring and qualifying non-GMO cultivated areas and its contamination. Second, non-GMO verification of final goods and third, seed program for DNA markers. Conserv also involves in creating awareness to farmers on the importance of heirloom and native varieties. Conserv has developed a seed bank program and an organic nursery program to scale-up sustainable bio-prospecting of cultivated species.",
      image: "/images/Sustainability/Conserv.png",
    },
    {
      title: "Farmlinx",
      description:"Farmlinx is an initiative for farmers' welfare. We focus on medium and small farmers, tribal farmers and small producers towards organic farming. Farmlinx group farmers for organic and bio-dynamic farming with integrated primary processing. In partnership with public institutions, co-operative and banks, we enable farmer groups in to producer organizations for value added production and economic progress. This initiative also reinforces confidences of farmers towards organic production. Indian Society for Certification of Organic Products (ISCOP) a society established for this purpose has taken lead to increase area under organic production, build farmer-based organizations and eventually enable social and economic progression of farmers.",
      image: "/images/Sustainability/Farmlinx.png",
    },
    {
      title: "QBD",
      description:"A traceability program for the supply chain based on principles of QBD, Quality By design. This is an evolving program under our Agliberte, that drives 'markers to market' integrity. The program shall offer 'immutable' quality records for the access of final consumer at three levels; Farm, Processing & Transit handling. The program also integrates final product DNA markers and its source identity. Currently the marker integration program is taken up at the crop production level, so by design the vulnerability assessment can be monitored.",
      image: "/images/Sustainability/QBD.png",
    },
    {
      title: "VCS-MPP",
      description:"Voluntary Certification System for Medicinal Plant Produce is the scheme run by Quality Council of India ensures the botanical fingerprints and identity of the plant source used for the production. Agliberte brings VCS-MPP for the raw materials involved in Orgavitaz.",
      image: "/images/Sustainability/VCS_MPP.png",
    },
    {
      title: "Carbon Footprint",
      description:"The traceability program also integrates carbon offset methodologies in the farming system evolving as an integrated project. Methane, Nitrous oxide and farm animal are the volume sources for low carbon footprint adapting approved methodologies of VERRA.",
      image: "/images/Sustainability/Carbon-Footprint.png",
    },
  ];

  const containerStyle = {
    overflowX: "hidden",
    maxWidth: "100%",
    margin: "0",
    padding: "0",
    backgroundColor: brandStyles.primaryGreen // Using brandStyles for consistency
  };

  const headerSectionStyle = {
    maxWidth: "1300px",
    margin: "0 auto",
    backgroundColor: brandStyles.primaryGreen,
    padding: "2rem 1rem 4rem 1rem",
  };

  const bannerStyle = {
    width: "100vw",
    maxWidth: "100vw",
    objectFit: "cover",
    marginBottom: "0",
    display: "block",
  };

  const headingStyle = {
    textAlign: "center",
    marginBottom: "2rem",
    fontSize: "2.5rem",
    color: brandStyles.deepBlue,
  };

  const leadStyle = {
    textAlign: "center",
    marginBottom: "4rem",
    fontSize: "1.1rem",
    color: 'white',
    lineHeight: "1.6",
  };

  const initiativeWrapperStyle = {
    display: "flex",
    flexWrap: "wrap",
    margin: "0",
    padding: "0",
    alignItems: "stretch",
    minHeight: "500px",
  };

  const commonColStyle = {
    flex: "1",
    minWidth: "50%",
    maxWidth: "50%",
    display: "flex", 
    flexDirection: "column",
    justifyContent: "center",
    margin: "0",
    padding: "0",
    // ADDED: position: 'relative' is crucial for the absolute frame overlay
    position: 'relative', 
  };

  const getTextContainerStyle = (index) => ({
    ...commonColStyle,
    // Using deepBlue/primaryGreen as a fallback background colour
    backgroundColor: index % 2 === 0 ? brandStyles.deepBlue : brandStyles.primaryGreen,
    padding: "4rem 3rem",
    // Ensure the container is set to display flex for centering, which is already in commonColStyle
  });

  const getImageContainerStyle = (index) => ({
    ...commonColStyle, 
    padding: "0",
    backgroundColor: index % 2 === 0 ? brandStyles.primaryGreen : brandStyles.deepBlue,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  });

  const titleStyle = {
    fontSize: "2rem",
    marginBottom: "1rem",
    color: "#ffffff",
    fontWeight: "bold",
    // ADDED: Set Z-index higher than the frame (0)
    zIndex: 1, 
  };

  const descriptionStyle = {
    fontSize: "1.1rem",
    lineHeight: "1.6",
    color: "#fffefeff",
    // ADDED: Set Z-index higher than the frame (0)
    zIndex: 1, 
  };
  
  const imageStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "transform 0.3s ease",
  };

  // --- NEW: Function to dynamically select the frame ---
  const getFrameOverlayStyle = (index) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    // Select BlueFrame for even indices (0, 2, 4...) and GreenFrame for odd indices (1, 3, 5...)
    backgroundImage: `url(${index % 2 === 0 ? BlueFrame : GreenFrame})`,
    backgroundSize: '100% 100%', 
    backgroundRepeat: 'no-repeat',
    zIndex: 0, // Ensure the frame is behind the text
  });

  const mediaQueryStyle = `
    @media (max-width: 768px) {
      .initiative-wrapper {
        flex-direction: column !important;
      }
      .initiative-col {
        min-width: 100% !important;
        max-width: 100% !important;
      }
    }
  `;

  return (
    <div style={containerStyle}>
      <style>{mediaQueryStyle}</style>
      
      {/* Full Width Banner */}
      <img src={bannerImage} alt="Sustainability Banner" style={bannerStyle} />

      {/* Header Section */}
      <div style={headerSectionStyle}>
        <h2 style={headingStyle}>Sustainability Initiatives</h2>
        <p style={leadStyle}>
          Sustainability is the heartbeat of Orgavitaz development. We believe in the livelihood mission of farmer groups and have integrated internal control systems (ICS) model for all the 26 crops involved in the supply chain. The sustainability as a value chain is integral to the product value chain. It involves community models (tribal) for forest biodiversity, community enclosure system for sustainable seed development, fair price system for crop value addition, climate responsible GAP-GMP, green logistics, non-GMO validation science, regenerative agroecological models and green manufacturing systems. Sustainability is a value-offer to our partners and consumers.
        </p>
      </div>

      {/* Initiatives Grid - No Gaps */}
     {initiatives.map((item, index) => {
        const isReverse = index % 2 === 1;
        return (
          <div 
            key={index}
            className="initiative-wrapper"
            style={{
              ...initiativeWrapperStyle,
              flexDirection: isReverse ? "row-reverse" : "row",
            }}
          >
            {/* --- IMAGE COLUMN with TITLE INSIDE IMAGE --- */}
            <div className="initiative-col" style={{ ...getImageContainerStyle(index), position: "relative" }}>
              <img
                src={item.image}
                alt={item.title}
                style={imageStyle}
              />
              {/* Title over image (top-left corner) */}
          {/*  <img src="/images/Sustainability/Ag-liberte_Logo.jpg" alt="Ag-liberte Logo" style={{ position: "absolute", bottom: "20px", right: "20px", width: "100px", height: "auto", zIndex: 2 }} /> */}
              <h3
                style={{
                  position: "absolute",
                  top: "20px",
                  left: "20px",
                  color: "#ffffffe5",
                  backgroundColor: "rgba(0,0,0,0.5)",
                  padding: "10px 15px",
                  borderRadius: "8px",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  margin: 0,
                  maxWidth: "80%",
                  zIndex: 2,
                }}
              >
                {item.title}
              </h3>
            </div>
            
            {/* --- TEXT COLUMN (without title now) --- */}
            <div className="initiative-col" style={getTextContainerStyle(index)}>
              <div style={getFrameOverlayStyle(index)}></div>
              <p style={descriptionStyle}>{item.description}</p>
            </div>
          </div>
        );
      })}
    </div>

  );
}